import React from 'react';
import { motion } from 'framer-motion';
import { Play, Star, Map } from 'lucide-react';
import { Link } from 'react-router-dom';

const Card = ({ title, icon: Icon, color, to, delay }) => (
    <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay, duration: 0.3 }}
    >
        <Link to={to} className={`block h-full p-6 rounded-3xl ${color} shadow-lg hover:shadow-xl hover:-translate-y-2 transition-all transform cursor-pointer text-white relative overflow-hidden group`}>
            <div className="absolute top-0 right-0 p-4 opacity-20 transform group-hover:scale-125 transition-transform duration-500">
                <Icon size={120} />
            </div>
            <div className="relative z-10">
                <div className="bg-white/20 w-16 h-16 rounded-2xl flex items-center justify-center mb-4 backdrop-blur-sm">
                    <Icon size={32} />
                </div>
                <h3 className="text-2xl font-bold mb-2">{title}</h3>
                <div className="flex items-center space-x-2 text-sm font-medium opacity-90">
                    <span>Entrar</span>
                    <Play size={16} fill="currentColor" />
                </div>
            </div>
        </Link>
    </motion.div>
)

const Home = () => {
    return (
        <div className="space-y-8">
            <div className="text-center space-y-4">
                <motion.h1
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="text-4xl md:text-6xl font-extrabold text-brand-purple"
                >
                    ¡Hola, Explorador! 👋
                </motion.h1>
                <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                    Bienvenido a tu aventura de geometría. ¿Qué quieres descubrir hoy?
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
                <Card
                    title="Geometría Mágica"
                    icon={Map}
                    color="bg-brand-blue"
                    to="/units"
                    delay={0.1}
                />
                <Card
                    title="Pizarra Creativa"
                    icon={Map}
                    color="bg-brand-pink"
                    to="/whiteboard"
                    delay={0.2}
                />
                <Card
                    title="Logros"
                    icon={Star}
                    color="bg-brand-yellow"
                    to="/achievements"
                    delay={0.3}
                />
            </div>
        </div>
    );
};

export default Home;
